import * as adTargetingParameterActions from './adTargetingParameterActions';
import * as airQualityActions from './airQualityActions';
import * as alertsActions from './alertsActions';
import * as almanacActions from './almanacActions';
import * as backgroundImageActions from './backgroundImageActions';
import * as contentManagementActions from './contentManagementActions';
import * as currentStationObsActions from './currentStationObsActions';
import * as historicalObsActions from './historicalObsActions';
import * as averageObsActions from './averageObsActions';
import * as feedbackActions from './feedbackActions';
import * as fireActions from './fireActions';
import * as forecastsActions from './forecastActions';
import * as forecastsActionsV5 from './forecastActionsV5';
import * as hurricaneActions from './hurricaneActions';
import * as iconActions from './iconActions';
import * as lightningActions from './lightningActions';
import * as locationActions from './locationActions';
import * as locationDetailsActions from './locationDetailsActions';
import * as locationSearchActions from './locationSearchActions';
import * as entityManagementSettingActions from './entityManagementSettingActions';
import * as loggingActions from './loggingActions';
import * as nowContentActions from './nowContentActions';
import * as pollenActions from './pollenActions';
import * as precipitationActions from './precipitationActions';
import * as storedLocationActions from './storedLocationActions';
import * as storiesActions from './storiesActions';
import * as coldFluActions from './coldFluActions';
import * as trafficCamActions from './trafficCamActions';
import * as uvActions from './uvActions';
import * as videoActions from './videoActions';
import * as weatherCamActions from './weatherCamActions';
import * as weekdayWeekendActions from './weekdayWeekendActions';
import * as arityActions from './arityActions';
import * as getFeatureDetailsAction from './mapFeatureDetailsActions';
import * as complianceInfoActions from './complianceInfoActions';
import * as mapActions from './mapActions';
import * as currentConditionActions from './currentConditionsActions';
import * as hourlyForecastActions from './hourlyForecastActions';
import * as roadForecastActions from './roadForecastActions';
import * as nowConditionsActions from './nowConditionsActions';
import * as hourlyForecastActionsV5 from './hourlyForecastActionsV5';
import * as hourlyForecastActionsV6 from './hourlyForecastActionsV6';
import * as outdoorSportsActions from './outdoorSportsActions';
import * as stationObsCurrentActions from './WeatherStationObservations/SelectedStation/selectedStationObservationsAction';
import * as allStationsObservationActions from './WeatherStationObservations/StationsList/allStationsObservationActions';
import * as hurricaneOutlookBulletinActions from './Hurricane/Outlook/Bulletin/hurricaneOutlookBulletinAction';
import * as hurricaneOutlookSummaryActions from './Hurricane/Outlook/Summary/hurricaneOutlookSummaryAction';

export const actions = {
    ...adTargetingParameterActions
    , ...airQualityActions
    , ...alertsActions
    , ...almanacActions
    , ...backgroundImageActions
    , ...contentManagementActions
    , ...currentStationObsActions
    , ...feedbackActions
    , ...fireActions
    , ...forecastsActions
    , ...forecastsActionsV5
    , ...hurricaneActions
    , ...iconActions
    , ...lightningActions
    , ...locationActions
    , ...locationDetailsActions
    , ...locationSearchActions
    , ...entityManagementSettingActions
    , ...loggingActions
    , ...nowContentActions
    , ...pollenActions
    , ...precipitationActions
    , ...storedLocationActions
    , ...storiesActions
    , ...trafficCamActions
    , ...uvActions
    , ...videoActions
    , ...weatherCamActions
    , ...weekdayWeekendActions
    , ...arityActions
    , ...getFeatureDetailsAction
    , ...coldFluActions
    , ...complianceInfoActions
    , ...mapActions
    , ...currentConditionActions
    , ...hourlyForecastActions
    , ...roadForecastActions
    , ...historicalObsActions
    , ...averageObsActions
    , ...nowConditionsActions
    , ...hourlyForecastActionsV5
    , ...hourlyForecastActionsV6
    , ...outdoorSportsActions
    , ...stationObsCurrentActions
    , ...allStationsObservationActions
    , ...hurricaneOutlookBulletinActions
    , ...hurricaneOutlookSummaryActions
};
